import { render } from "./TagsInputField.vue?vue&type=template&id=55ebda2c"
import script from "./TagsInputField.vue?vue&type=script&lang=js"
export * from "./TagsInputField.vue?vue&type=script&lang=js"

import "./TagsInputField.vue?vue&type=style&index=0&id=55ebda2c&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__